import { render } from "./AyandehButton.vue?vue&type=template&id=c48d25d8"
import script from "./AyandehButton.vue?vue&type=script&lang=js"
export * from "./AyandehButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__